export enum ZoekVelden {
    opdrachtnummer = 'Opdrachtnummer',
}